import { DatatableComponent, TableColumn } from "@swimlane/ngx-datatable";
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import { TemplatedComponent } from "../components/datatable-2-csv/templated.component";
import { ComponentFactoryResolver, Injector, Injectable } from "@angular/core";

@Injectable()
export class DatatableService {
    constructor(private _injector: Injector, private _resolver: ComponentFactoryResolver) { }

    exportAsCSV(dataTable: DatatableComponent) {
        const columns: TableColumn[] = dataTable.columns || dataTable._internalColumns;
        const headers =
            columns
                .map((column: TableColumn) => column.name)
                .filter((e) => e);  // remove column without name (i.e. falsy value)

        const rows: any[] = dataTable.rows.map((row) => {
            let r = {};

            columns.forEach((column) => {
                if (!column.name) { return; }   // ignore column without name

                var prop
                var propValue;
                if (column.prop) {
                    prop = column.prop.toString();
                    propValue = getNestedPropertyValue(row, prop);
                }

                if (column.cellTemplate) {
                    r[column.name] = getRenderedTemplateText(column.cellTemplate, propValue, row, this._resolver, this._injector);
                } else {
                    r[column.name] = (typeof propValue === 'boolean') ? (propValue ? 'Yes' : 'No') : propValue;
                }
            });

            return r;
        });

        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: headers,
            showTitle: false,
            title: 'Report',
            useBom: true
        };

        return new AngularCsv(rows, 'report', options);
    }
}


function getRenderedTemplateText(template, value, row, resolver: ComponentFactoryResolver, injector: Injector) {
    const factory = resolver.resolveComponentFactory(TemplatedComponent);
    const component = factory.create(injector);

    component.instance.template = template;
    component.instance.context = { value: value, row: row };
    component.changeDetectorRef.detectChanges();

    return component.location.nativeElement.textContent.trim();
}

function getNestedPropertyValue(object: any, nestedPropertyName: string) {
    var dotIndex = nestedPropertyName.indexOf(".");
    if (dotIndex == -1) {
        return object[nestedPropertyName];
    } else {
        var propertyName = nestedPropertyName.substring(0, dotIndex);
        var nestedPropertyNames = nestedPropertyName.substring(dotIndex + 1);

        return getNestedPropertyValue(object[propertyName], nestedPropertyNames);
    }
}
